import { Property, PropertyRequest } from '../types/property';

export const setPropertyImages = (data) => {
  if (data.property.floorPlanImage) {
    data.property.filesFloorPlan = {
      src: `${process.env.REACT_APP_AWS_S3_URL}/properties/${data.property.floorPlanImage}.jpg`,
      key: data.property.floorPlanImage,
    };
  }
  if (data.property.locationMapImage) {
    data.property.filesMapImage = {
      src: `${process.env.REACT_APP_AWS_S3_URL}/properties/${data.property.locationMapImage}.jpg`,
      key: data.property.locationMapImage,
    };
  }
  if (data.property.badroomImage) {
    data.property.filesBedroom = {
      src: `${process.env.REACT_APP_AWS_S3_URL}/properties/${data.property.badroomImage}.jpg`,
      key: data.property.badroomImage,
    };
  }
  if (data.property.bathroomImage) {
    data.property.filesBathroom = {
      src: `${process.env.REACT_APP_AWS_S3_URL}/properties/${data.property.bathroomImage}.jpg`,
      key: data.property.bathroomImage,
    };
  }
  if (data.property.outspaceImage) {
    data.property.filesOutspace = {
      src: `${process.env.REACT_APP_AWS_S3_URL}/properties/${data.property.outspaceImage}.jpg`,
      key: data.property.outspaceImage,
    };
  }
  if (data.property.cardImage) {
    data.property.filesCard = {
      src: `${process.env.REACT_APP_AWS_S3_URL}/properties/${data.property.cardImage}.jpg`,
      key: data.property.cardImage,
    };
  }
  if (data.property.mobileCardImage) {
    data.property.filesMobileCard = {
      src: `${process.env.REACT_APP_AWS_S3_URL}/properties/${data.property.mobileCardImage}.jpg`,
      key: data.property.mobileCardImage,
    };
  }
  if (data.property.emailGalleryImage) {
    data.property.filesEmailGallery = {
      src: `${process.env.REACT_APP_AWS_S3_URL}/properties/${data.property.emailGalleryImage}.gif`,
      key: data.property.emailGalleryImage,
    };
  }
  if (data.property.galleryImages && data.property.galleryImages.length > 0) {
    let galleryImages = data.property.galleryImages.map((item) => {
      return {
        src: `${process.env.REACT_APP_AWS_S3_URL}/properties/${item}.jpg`,
        key: item,
      };
    });
    data.property.filesGallery = galleryImages;
  }

  return data;
};
export const setBlogPostImages = (data) => {
  if (data.previewImage) {
    data.filesPreviewImage = {
      src: `${process.env.REACT_APP_AWS_S3_URL}/blogs/${data._id}/${data.previewImage}.jpg`,
      key: data.previewImage,
    };
  }
  if (data.galleryImages && data.galleryImages.length > 0) {
    let galleryImages = data.galleryImages.map((item) => {
      return {
        src: `${process.env.REACT_APP_AWS_S3_URL}/blogs/${data._id}/assets/${item}.jpg`,
        key: item,
      };
    });
    data.filesGallery = galleryImages;
  }
  return data;
};
export const setPropertyWinnerPhoto = (data) => {
  if (data.photoUrl) {
    data.photoUrl = {
      src: `${process.env.REACT_APP_AWS_S3_URL}/winnersPhotos/${data.photoUrl}.jpg`,
      key: data.photoUrl,
    };
  }
  if (data.winnerPhotoUrl) {
    data.winnerPhotoUrl = {
      src: `${process.env.REACT_APP_AWS_S3_URL}/winnersPhotosPeople/${data.winnerPhotoUrl}.jpg`,
      key: data.winnerPhotoUrl,
    };
  }
  return data;
};
export const filterGalleryImages = (
  data: PropertyRequest
): Array<string> | undefined => {
  if (data.filesGallery) {
    data.galleryImages = [];
    data.filesGallery.forEach((i) => {
      if (data.galleryImages) {
        if (i.key) data.galleryImages.push(i.key);
      }
    });
    data.filesGallery = data.filesGallery.filter(
      (i) => !i.hasOwnProperty('key')
    );
    return data.galleryImages;
  }

  return undefined;
};
